import { useContext } from 'react';
import { NotificationContext } from './notification-context';
/** Zugriff auf den Benachrichtigungs-Store. Erfordert `<NotificationProvider>`. */
export function useNotifications() {
    const ctx = useContext(NotificationContext);
    if (!ctx) {
        throw new Error('useNotifications() muss innerhalb von <NotificationProvider> verwendet werden.');
    }
    return ctx;
}
